import React from 'react';
import { useTranslation } from 'react-i18next';
import GradientText from './GradientText';
import YouTubeLite from './YouTubeLite';

const DemoVideo = () => {
  const { t, i18n } = useTranslation();

  return (
    <section id="demo" className="pt-6 pb-16 md:pt-10 md:pb-24 bg-background text-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">

          {/* Text Section with Animated Gradient */}
          <div className="mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center leading-tight">
              {(() => {
                const currentLang = i18n.language;

                if (currentLang === 'it') {
                  return (
                    <span className="inline-flex flex-wrap items-baseline justify-center gap-x-2 gap-y-1">
                      <span>Guarda come raggiungerai</span>
                      <GradientText
                        colors={['#9cff1e', '#ffde59', '#0cc0df', '#9cff1e', '#ffde59']}
                        animationSpeed={5}
                        showBorder={false}
                      >
                        i tuoi obiettivi
                      </GradientText>
                    </span>
                  );
                } else {
                  return (
                    <span className="inline-flex flex-wrap items-baseline justify-center gap-x-2 gap-y-1">
                      <span>See how you'll succeed in</span>
                      <GradientText
                        colors={['#9cff1e', '#ffde59', '#0cc0df', '#9cff1e', '#ffde59']}
                        animationSpeed={5}
                        showBorder={false}
                      >
                        your goals
                      </GradientText>
                    </span>
                  );
                }
              })()}
            </h2>
          </div>

          {/* Video Embed Section with Arrow */}
          <div className="mb-12 md:mb-16 max-w-full relative">
            {/* Arrow positioned to match exactly as in the screenshot - desktop version */}
            <div className="absolute -left-32 lg:-left-40 top-1/4 transform hidden md:block">
              <img 
                src="/images/freccia_video.svg" 
                alt="Arrow" 
                className="w-28 h-28 lg:w-36 lg:h-36 text-secondary transform -scale-x-100"
              />
            </div>
            
            {/* Mobile Arrow - smaller and positioned to match design */}
            <div className="absolute -left-12 top-1/4 transform block md:hidden">
              <img 
                src="/images/freccia_video.svg" 
                alt="Arrow" 
                className="w-16 h-16 text-secondary transform -scale-x-100"
              />
            </div>
            <YouTubeLite
              videoId="pbuqxY9vJZU"
              title={t('demoVideo.videoTitle', "Fitness App Demo Video")}
            />
          </div>


        </div>
      </div>
    </section>
  );
};

export default DemoVideo;
